import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllStatus extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    status:[],
    allCountries:[]
  }

  apiRequest = params => {
    return new Promise(async resolve => {
    //   this.setState({exportParams: params})
      let data = await this.getAllStatus({
        ...params,
        regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  getAllStatus = async()=>{
    let response = await Request.getStatusDetails({
        results:1000,
        count:1000,
    })
    return response
  }

  getAllCountries =()=>{
    let params = {
        results: 100,
        sortField: 'countryName',
        sortOrder: 'ascend'
    }
    Request.getCountries(params).then((resp)=>{
        if(resp) {
            let countries = [{display:'---Select All---', id:'all'}];
            _.each(resp.data, (vv) =>{
                countries.push({
                    display:vv.countryName,
                    id:vv._id
                })
            });
            this.setState({allCountries:countries})
        }
    }).catch((err) => {
    });
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateStatusDetails(values) //For Updating Data
        } else {
          x = await Request.addStatusDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0'
          })
          notification.success({
            message: this.state.id
              ? `Status Updated Successfully`
              : 'Status Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              statusName: '',
              countryIds:'',
              statusType:'',
              status:''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteStatusDetails = async data =>{
    this.setState({loading:true})
    await Request.deleteStatusDetails(data)
    this.setState({loading:false})
    this.table.current.reload();
    notification.success({
        message: 'Deleted Successfully',
        duration: 20,
        key: `${data._id}-close`
      })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setStatusDetailsData(statusDetailId) {
    if(statusDetailId) {
        Request.statusDetailByID({id:statusDetailId}).then(
            ({doc,error,message})=>{
                if(!error && doc) {
                    this.setState({
                        id: doc._id,
                        activeTab: '1'
                    })
                this.props.form.setFieldsValue({
                    statusName:doc.statusName,
                    countryIds:doc.countryIds,
                    statusType:doc.statusType,
                    status:doc.status
                })
                }else {
                    notification.error({
                      message: 'Error Getting Data',
                      description: message
                    })
                  }
            }
        )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
    await this.getAllCountries()
    let response = await Request.getCountries();
    await this.getAllStatus();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id, allCountries} = this.state;

    const inputTypes = {
      fields: [
        {
            label:"Status Name",
            key:"statusName",
            required:true
        },
        {
            label:"Country",
            key:"countryIds",
            type:'select',
            mode:'multiple',
            options:allCountries,
            showSearch: true,
            required:true,
            onChange:v=>{
                let val = v ? v : [];
                if (v && v.length && v.includes("all")) {
                    if (v.length === allCountries.length) {
                        val = [];
                    } else {
                        val=allCountries.slice(1).map(levelOption => levelOption.id)
                        
                    }
                }
                this.props.form.setFieldsValue({countryIds:val})
            }
        },
        {
            label:"Type",
            key:"statusType",
            type:'select',
            options:['Visa Status', 'Admission Status', 'Application Status', 'File Status'],
            required:true,
            onChange:v=>{
                this.props.form.setFieldsValue({statusType:v})
            }
        },
        {
            label:'Entry Status',
            key:'status',
            type:'select',
            options:['Active', 'Inactive'],
            required:true,
            onChange:v=>{
                this.props.form.setFieldsValue({status:v})
            }
        }
      ]
    };

    const columns = [
      {
        title: 'Status Name',
        key: 'statusName',
      },
      {
        title: 'Type',
        key: 'statusType',
      },
      {
        title: 'Entry Status',
        key: 'status',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId?
          <React.Fragment>
            <RightsWrapper myRight={'status.edit'}>
              <Tooltip title="Edit Status">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setStatusDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'status.delete'}>
              <Tooltip title="Delete Status">
                <Popconfirm
                  title="Are you sure delete this Status?"
                  onConfirm={() => {
                    this.deleteStatusDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
          :null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Status Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Status`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Status'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllStatus
